var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',{staticClass:"form-list"},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._t("title")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{attrs:{"slot":"append"},slot:"append"},[_vm._t("append")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-9a0f3526","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/form.vue
// module id = null
// module chunks = 